
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

const Hero = () => {
  const isMobile = useIsMobile();

  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden bg-gradient-to-br from-[#0c4a6e] to-[#075985] w-full">
      {/* Background pattern overlay */}
      <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:30px_30px] pointer-events-none"></div>
      
      {/* Accent circles */}
      <div className="absolute top-1/4 -left-20 w-80 h-80 bg-[#0EA5E9]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 -right-20 w-80 h-80 bg-[#D946EF]/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 py-16 relative z-10 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div className="text-center md:text-left">
            <div className="inline-flex items-center px-3 py-1.5 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm mb-6 shadow-sm mx-auto md:mx-0">
              <span className="text-xs md:text-sm font-medium text-white/90">AGENCIA DE SEGUROS PROFESIONAL</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-display font-medium text-white leading-tight mb-6 mx-auto md:mx-0 max-w-2xl">
              Protección y tranquilidad con 
              <span className="text-[#33C3F0] block mt-2">seguros a tu medida</span>
            </h1>
            
            <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto md:mx-0">
              Ofrecemos soluciones de seguros personalizadas que se adaptan a tus necesidades específicas, con el respaldo de las mejores aseguradoras del mercado.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
              <a 
                href="tel:+17865695142" 
                className="inline-flex items-center justify-center rounded-md px-8 h-12 bg-white text-[#0c4a6e] hover:bg-white/90 shadow-lg"
              >
                <Phone className="mr-2 h-4 w-4" />
                Llama Ahora: (888) 370-8454
              </a>
              <Button 
                variant="outline" 
                size="lg" 
                className="rounded-md px-8 h-12 border-white/30 text-white bg-white/5 hover:bg-white/10 backdrop-blur-sm shadow-lg"
                onClick={scrollToContact}
              >
                Solicitar Cotización
                <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
          
          {/* Customer service image */}
          <div className={`${isMobile ? 'flex' : 'hidden'} md:flex justify-center items-center`}>
            <div className="relative">
              <div className="absolute -inset-4 bg-white/10 rounded-full blur-xl"></div>
              <img 
                src="/lovable-uploads/3fb524f9-ccd9-442f-b2df-ceffe5d0b180.png" 
                alt="Atención al cliente" 
                className="relative z-10 max-h-[500px] object-contain drop-shadow-2xl animate-float"
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Diagonal cut at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-background transform -skew-y-2 origin-left"></div>
    </section>
  );
};

export default Hero;
